import BrandingScene from '../../scenes/MarketingPages/scenes/BrandedStreams';

export default BrandingScene;
